<template>
  <!-- 区域能耗 -->
  <div class="t" style="position: relative;">
    <div class="con">
       <div class="Files-top">
            <div class="ic-left">
              <span>区域能耗</span>
            </div>
            <div class="btns">
              <el-button type="primary" size="mini"  @click="exportList" class="last-el-button">导出</el-button>
            </div>
       </div>
        <div class="search-input-btn">
              <div class="input-small myinput">
                  <span>能源类型：</span>
                   <el-select v-model="energyType" placeholder="请选择" style="width:160px">
                    <el-option v-for="item in typeOptions" :key="item.appTypeNo" :label="item.typeName" :value="item.appTypeNo">
                    </el-option>
                  </el-select>
              </div>
              <div class="input-small myinput" style="margin:0px 20px;">
                  <span>时间：</span>
                   <el-select v-model="timeType" placeholder="请选择" style="width: 160px;" @change="timeType_fn">
                      <el-option label="日" value="DAY"> </el-option>
                      <el-option label="月" value="MONTH"> </el-option>
                      <el-option label="年" value="YEAR"> </el-option>
                    </el-select>
              </div>
              <div class="input-small">
                    <el-date-picker class="picker" v-model="dateValue" type="date" placeholder="请选择日期" v-if="dateType == 'DAY'"
                      :picker-options="pickerOptions"></el-date-picker>
                    <el-date-picker class="picker" v-model="dateValue" type="month" placeholder="请选择月份" v-if="dateType == 'MONTH'"
                      :picker-options="pickerOptions"></el-date-picker>
                    <el-date-picker class="picker" v-model="dateValue" type="year" placeholder="请选择年份" v-if="dateType == 'YEAR'"
                      :picker-options="pickerOptions"></el-date-picker>
              </div>
              <el-button type="primary" size="mini" plain @click="getList" class="search-btn">查询</el-button>
        </div>
      
        <!-- 第二层 -->
        <div class="two-echart">
              <div class="echart echart1">
                <div class="echart-title">区域-综合用能-{{dateType | timerType_fn}}统计</div>
                <div id="echart"></div>
              </div>
              <div class="echart echart2">
                <div class="echart-title">区域-综合用能-{{dateType | timerType_fn}}分布</div>
                <div id="echart2" style="width: 100%;height: 320px;"></div>
              </div>
 
        </div>
        <!-- 建筑分类实时总能耗为： -->
        <div class="table_t" id="region-cost">
          <div class="echart-title">区域分类实时总能耗为：<span>{{energyTotal | Total_fn}} {{energyType | energyType_fn}}</span></div>
          <div class="comtent">
            <el-table
              stripe :data="tableData" border style="width: 100%" :max-height="heights">
                <template slot="empty">
            <span class="noData">
              <img src="@/assets/noData.png" alt="暂无数据">
              <span class="text">暂无数据</span>
            </span>
          </template>
              <el-table-column prop="date" label="建筑" width="165" > </el-table-column>
              <el-table-column prop="name" align="center" label="实时总能耗" width="165" > </el-table-column>
              <el-table-column v-for="(item,index) in columns" :key='index' :prop="item.key" :label="item.name"
                :align="item.al" width="165"> </el-table-column>
            </el-table>
          </div>
        </div>
    </div>
    <!-- 遮罩层 -->
    <div class="mask" v-if="isMask">
      <i class="el-icon-loading" style="color:#409eff;font-size:60px"></i>
    </div>
    <downloadTable ref="downloadTable"></downloadTable>
  </div>
</template>

<script>
  //   import { AppModuleRight } from "@/utils/request";
  import {getAllEnergyType} from "../../../api/energySubType";
  import {getAreaEnergy} from "../../../api/overView";
  import downloadTable from '@/components/module/downloadTable/downloadTable.vue'
  import * as echarts from "echarts";
  import $ from 'jquery';
  var echart,echart2;
  export default {
    components: {
      downloadTable
    },

    data () {
      return {
         heights: document.getElementById('app').clientHeight-650,//屏幕高度 - 导航栏高度
        pickerOptions: {
          disabledDate (time) {
            return time.getTime()>Date.now();
          },

        },
        isMask: false,
        columns: [],
        tableData: [],
        middleData: {
          legend: {
            // data: ["1号建筑", "2号建筑", "3号建筑", "4号建筑",],
            data: [],
            top: 275,
            type: 'scroll',
            icon: "circle", //  这个字段控制形状  类型包括 circle，rect ，roundRect，triangle，diamond，pin，arrow，none
            itemWidth: 10, // 设置宽度
            itemHeight: 10, // 设置高度
            textStyle: {
              lineHeight: 56,
              fontSize: 14
            },
            itemGap: 20 // 设置间距
          },
          grid: {
            top: "12% ",
            left: 52,
            right: 12,
            bottom: 60
          },
          tooltip: {
            trigger: "axis",
            axisPointer: {
              // Use axis to trigger tooltip
              type: "shadow" // 'shadow' as default; can also be 'line' or 'shadow'
            }
          },
          toolbox: {
            show: true,
            showTitle: true, // 隐藏默认文字，否则两者位置会重叠
            right: '2%',
            top: '-2%',
            feature: {
              magicType: {
                type: ['line','bar','stack','tiled'],title: {
                  line: '切换为折线图',
                  bar: '切换为柱状图',
                  stack: '切换为堆叠',
                  tiled: '切换为平铺',
                }
              },
              saveAsImage: {
                show: true,
                title: '下载图片'
              },
              // dataView: { show: true, readOnly: true, lang: ['', '关闭'] },
            },
            tooltip: { // 和 option.tooltip 的配置项相同
              show: false,
              formatter: function(param) {
                return '<div>'+param.title+'</div>'; // 自定义的 DOM 结构
              },
              backgroundColor: '#fff',
              textStyle: {
                fontSize: 12,
              },
              extraCssText: 'box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);' // 自定义的 CSS 样式
            }
          },
          color: ["#60ACF2",'#6071F2','#FBD437','#36CBCB','#F56C6C','#67C23A','#409EFF','#E6A23C','#909399'],

          xAxis: {
            splitLine: {
              //网格线
              show: true
            },
            splitArea: {
              //坐标轴在 grid 区域中的分隔区域，默认不显示。
              interval: "auto",
              show: false, //是否显示分隔区域
              areaStyle: {
                color: ["rgba(250,250,250,0.3)","rgba(200,200,200,0.3)"], //分隔区域颜色。分隔区域会按数组中颜色的顺序依次循环设置颜色。默认是一个深浅的间隔色。
                shadowColor: "red", //阴影颜色
                shadowOffsetX: 0, //阴影水平方向上的偏移距离。
                shadowOffsetY: 0, //阴影垂直方向上的偏移距离
                shadowBlur: 10, //图形阴影的模糊大小。
                opacity: 1 //图形透明度。支持从 0 到 1 的数字，为 0 时不绘制该图形
              }
            },
            type: "category",
            axisTick: {
              show: false
            },
            axisLabel: {
              interval: 0,
              rotate: 0,
              inside: false
            },
            axisLine: {
              show: false
            },
            z: 99,
            data: [
              "00：00",
              "00：15",
              "00：30",
              "00：45",
              "01：00",
              "01：15",
              "01：30",
              "01：45",
              "02：00",
              "02：15",
              "02：30",
              "03：00",
            ]
          },
          yAxis: {
            type: "value"
          },
          series: []
        },
        typeOptions: [],
        options2: {
          tooltip: {
            trigger: "item"
          },
          legend: {
            data: [],
            top: 295,
            width: 360,
             type: 'scroll',
            icon: "circle", //  这个字段控制形状  类型包括 circle，rect ，roundRect，triangle，diamond，pin，arrow，none
            itemWidth: 12, // 设置宽度
            itemHeight: 12, // 设置高度
            textStyle: {
              lineHeight: 20,
              fontSize: 14
            },
            itemGap: 20, // 设置间距
             
          },
          label: {
            alignTo: "edge",
            formatter: "{name|{b}}\n{time|{c}}",
            minMargin: 5,
            edgeDistance: 10,
            lineHeight: 15,
            rich: {
              time: {
                fontSize: 10,
                color: "#999"
              }
            }
          },


           color: ["#60ACF2",'#6071F2','#FBD437','#36CBCB','#F56C6C','#67C23A','#409EFF','#E6A23C','#909399'],
          series: [
            {
              name: "分项用能分析",
              type: "pie",
              radius: "55%",
              center: ["50%","50%"],
              itemStyle: {
                borderColor: "#fff",
                borderWidth: 1
              },
              data: [],
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: "rgba(0, 0, 0, 0.5)"
                }
              }
            }
          ]
        },
        energyType: "",
        timeType: "DAY",
        dateValue: "",
        dateType: "DAY",
        nowArea: {},//当前区域
        dayData: [],
        monthData: [],
        yearData: [],
        energyTotal: 0
      };
    },
    //利用计算属性
    computed: {
      defaultTheme () {
        return this.$store.state.settings.style
      },
      nowBuilding () {//当前建筑
        return this.$store.cacheStore.state.setBuilding;
      }
    },

    //监听执行
    watch: {
      nowBuilding (val) {

        this.nowArea=val
        //  this.temp_fn(this.timerType)
      },
      energyType (val) {
        if(val=="36") {
          this.options2.label.formatter="{name|{b}}\n{time|{c}kwh}"
        } else if(val=="002") {
          this.options2.label.formatter="{name|{b}}\n{time|{c}t}"
        } else if(val=="361") {
          this.options2.label.formatter="{name|{b}}\n{time|{c}m³}"
        }
      }
    },
    mounted () {

      for(let i=1;i<=31;i++) {
        if(i<=24) {

          this.dayData.push(i>9? i+':00':'0'+i+':00')
        }
        if(i<=12) {
          this.yearData.push(i+'月')
        }
        this.monthData.push(i+'号');
      }
      this.middleData.xAxis.data=this.dayData;
      this.nowArea=this.$store.cacheStore.state.setBuilding
      this.init();
      var date=new Date()
      var str=date.getFullYear()+'-'+(date.getMonth()+1)+'-'+date.getDate()
      var today=new Date(str)
      this.dateValue=today
      // console.log("时间",today);
      this.timerDate=0
      this.timerDate+=1
      this.getAllEnergyTypeFun()



    },
    methods: {
      // 下载excel
      exportList () {
        let time=new Date();
        let year=time.getFullYear();
        let month=time.getMonth()+1;
        let day=time.getDate();
        var type=this.typeOptions.filter(item => item.appTypeNo==this.energyType)
        var timeType=""
        if(this.timeType=='DAY') {
          timeType="日"
        } else if(this.timeType=='MONTH') {
          timeType="月"
        } else {
          timeType="年"
        }
        const tHeader=['能源区域',this.nowBuilding.name,'能源类型',type[0].typeName,'周期',timeType,"查询时间",this.date_format_fn(this.dateValue)];
        //  this.export2Excel(tHeader,this.tableData,year + "-" + month + "-" + day + '-能耗排名');
        this.$refs.downloadTable.export2Excel(tHeader,this.tableData,year+"-"+month+"-"+day+'-区域能耗','#region-cost')
      },
      //初始化图表
      init () {
        // 建筑-综合用能-日统计
        echart=echarts.init(document.getElementById("echart"));
        echart.setOption(this.middleData);
        echart.resize({height: 320});
        // 建筑-综合用能-日分布
        echart2=echarts.init(document.getElementById("echart2"));
        echart2.setOption(this.options2);
        echart2.resize({height: 320});
        //浏览器窗口发生变化时，重置报表大小
        $(window).resize(function() {
          // myChart.resize({ height: 260 });
          echart2.resize();
        });
      },
      //时间类型变化
      timeType_fn (val) {
        this.dateType=val
        this.dateValue=""
      },
      //获取能源类型
      getAllEnergyTypeFun () {
        getAllEnergyType().then(res => {
          if(res.code==200) {
            this.typeOptions=res.data
            this.energyType=res.data[0].appTypeNo
            // this.tableData = res.data

            this.getList()
          }
        })


      },
       color16 () {//十六进制颜色随机
        var r=Math.floor(Math.random()*256);
        var g=Math.floor(Math.random()*256);
        var b=Math.floor(Math.random()*256);
        var color='#'+r.toString(16)+g.toString(16)+b.toString(16);
        if(color.length != 7){
          this.color16()
        }else {
              var myIndex  = ""
              myIndex = this.mycolorArr.findIndex(item => item == color)
              if(myIndex == -1){
                     this.mycolorArr.push(color)
             }else {
                    this.color16()
              }
        }

      },
      getList () {
        if(this.dateValue=='') {
          this.$message({message: `请选择时间`,type: 'warning'});
          return
        }
        this.isMask=true
        if(this.timerDate==1) {
          // var dateTimer =  (this.dateValue).getTime() - 28800000
          var dateTimer=(this.dateValue).getTime()
        } else {
          var dateTimer=(this.dateValue).getTime()
        }
        // if()
        var d={
          'areaId': this.nowArea.id,
          'date': dateTimer,
          // 'date':'1672999000000',
          'timeType': this.timeType,
          'energyType': this.energyType
        }
        this.timerDate=0
        this.energyTotal=0
        getAreaEnergy(d).then(res => {
          // console.log("页面数据",res);
          if(res.code==200) {
            this.isMask=false;
            if(this.timeType=='DAY') {
              this.middleData.xAxis.data=this.dayData;
            } else if(this.timeType=='MONTH') {
              this.middleData.xAxis.data=this.monthData;
            } else if(this.timeType=='YEAR') {
              this.middleData.xAxis.data=this.yearData;
            }
            this.mycolorArr =  ["#60ACF2",'#6071F2','#FBD437','#36CBCB','#F56C6C','#67C23A','#409EFF','#E6A23C','#909399'],
            res.data.subAreaConsumptionVo.forEach(res => {
                this.color16()
            })
            //区域分布
            this.squipment_fn(res.data.subAreaConsumptionVo);
            //区域统计
            this.subAreaConsumptionVo_fn(res.data.subAreaConsumptionVo)
          } else {
            this.isMask=false;
            this.$message({message: `获取失败${res.message}`,type: 'error'});
          }
        })
      },

      //处理区域分布
      squipment_fn (val) {
        this.options2.legend.data=[];
        this.options2.series[0].data=[];
        // for(var key in val) {
        //   this.options2.legend.data.push(key);
        //   this.options2.series[0].data.push({
        //     value: val[key],
        //     name: key,
        //   });
        // }
        val.map(v => {
          this.options2.legend.data.push(v.areaName);
          this.options2.series[0].data.push({
            value: v.total,
            name: v.areaName,
          })
        });
        this.options2.color = this.mycolorArr
        echart2.setOption(this.options2,true);
      },
      //处理区域统计
      subAreaConsumptionVo_fn (val) {
        this.middleData.legend.data=[]
        this.middleData.series=[]
        this.tableData=[]
        this.columns=[]
        this.tableData=[{
          date: "建筑",
          name: "实时总能耗",
        }]
        var additional=[]
        if(this.timeType=='DAY') {
          additional=this.dayData
        } else if(this.timeType=='MONTH') {
          additional=this.monthData
        } else if(this.timeType=='YEAR') {
          additional=this.yearData
        }
        // console.log("上课借记卡",additional);

        val.forEach((item,index) => {
          this.middleData.legend.data.push(item.areaName)
          this.middleData.series.push({
            name: item.areaName,
            data: [],
            type: "bar",
            stack: 'total',
            emphasis: {
              focus: 'series'
            },
            // barWidth: 25 //柱图宽度
          })
          this.tableData.push({
            'date': item.areaName,
            'name': item.total,
          })
          this.energyTotal+=item.total
          var i=0
          if(item.timeConsumption){
            for(let key in item.timeConsumption[0]) {
            this.middleData.series[index].data.push(item.timeConsumption[0][key])
            this.tableData[index+1][key]=(item.timeConsumption[0][key])
            this.tableData[0][key]=additional[i]
            if(index==0) {
              this.columns.push({
                'name': additional[i],
                'key': key,
                'al': 'center'
              })
            }
            i++

          }
          }
         

        })
        this.tableData.shift()
        this.middleData.color = this.mycolorArr
        echart.setOption(this.middleData,true);
        //  console.log("this.middleData.series",this.middleData.series);


      },

      tableRowClassName ({row,rowIndex}) {
        if(rowIndex%2===0) {
          return "success-row";
        }
      },
      // 转换时间戳
      date_format_fn (value) {
        if(!value) {
          return ""
        }
        let date=new Date(value);
        let Y=date.getFullYear()+'-';
        let M=(date.getMonth()+1<10? '0'+(date.getMonth()+1):date.getMonth()+1)+'-';
        let D=(date.getDate()<10? '0'+(date.getDate()):date.getDate())+' ';

        let h=(date.getHours()<10? '0'+(date.getHours()):date.getHours())+':';
        let m=(date.getMinutes()<10? '0'+(date.getMinutes()):date.getMinutes())+':';
        let s=(date.getSeconds()<10? '0'+(date.getSeconds()):date.getSeconds());
        let strDate=Y+M+D+h+m+s;
        return `'${strDate}'`
      },
    },
    filters: {
      //类型 DAY(日)  MONTH(月) YEAR(年)
      timerType_fn (val) {
        if(val=='DAY') {
          return "日"
        } else if(val=='MONTH') {
          return "月"
        } else {
          return "年"
        }
      },
      //保留俩位小数点
      Total_fn (val) {
        return val.toFixed(2)
      },
      energyType_fn (val) {
        var d=''
        if(val=="36") {
          d="kw·h"
        } else if(val=="002") {
          d='t'
        } else if(val=="361") {
          d="m³"
        }
        return d
      }

    }
  };
</script>
<style>
  .mask {
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2020;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .t .bottom .el-input__inner {
    /* background: #5da7e8; */
    /* color: #fff; */
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    text-align: center;
  }

  .t .bottom .picker .el-input__inner {
    background: #fff;
    color: #000;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    text-align: left;
    transform: translateY(2px);
  }
</style>
<style lang="scss" scoped>
  .t {
    // padding: 20px;

    .paginationed {
      border-top: none;
      display: flex;
      justify-content: flex-end;
      padding: 10px 0;
      margin-top: 10px;
    }
    .con {
      width: 100%;
      height: 100%;
      background-color: #fff;
      padding:12px 20px;
      box-sizing: border-box;
    }
    .two-echart {
      width: 100%;
      height: 305px;
         display: flex;
        
     .echart1 {
      width: 75%;
          border-right: 1px solid #e6e6e6;
     }
     .echart2 {
      width: 25%;
     }
    }
    // 建筑-综合用能-日统计
    .table_t {
      box-sizing: border-box;
      position: relative;
      margin-top: 35px;
       border-top: 1px solid #e6e6e6;
     .echart-title {
          top: 15px;
          span {
            font-weight: bolder;
            font-size: 16px;
            color: #FF7C1D;
          }
     }
     

      .comtent {
        margin-top: 53px;
      }
    }
    .echart-title {
          font-size: 16px;
          position: absolute;
          top: -3px;
          left: 50%;
          transform: translateX(-50%);
          color: #666666;
        }

    .echart {
      height: 315px;
      box-sizing: border-box;
      position: relative;
      margin-top: 5px;

      
    }

   
  }
</style>